import Button, { ButtonGroup } from "components/bootstrap/Button";
import FormGroup from "components/bootstrap/forms/FormGroup";
import Input from "components/bootstrap/forms/Input";
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from "components/bootstrap/Modal";
import showNotification from "components/extras/showNotification";
import { Trans, useTranslation } from "react-i18next";
import Alert from "components/bootstrap/Alert";
import { InfoOutline } from "components/icon/material-icons";
import AuthService from "services/AuthService";
import { useEffect, useState } from "react";

/******************************************************************
 * 파일명 : frontend2\src\pages\common\Headers\components\JoinCompanyModal.js
 * 설명 : 상단 util 영역 > 설정 모달 > 회사 변경 탭 > 신규 추가 모달
 ******************************************************************/

const JoinCompanyModal = ({
    isModal,
    setIsModal,
    onCreated
}) => {
    const { t } = useTranslation();
    const [code, setCode] = useState('');

    // 초대 이메일 링크로 접속했을 때 모달 자동 오픈 + 코드 자동 입력
    useEffect(() => {
        if (location.search) {
            const params = new URLSearchParams(location.search);
            const code = params.get("code");
            if (code) {
                setIsModal(true);
                setCode(code);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isModal) {
            setCode('');
        }
    }, [isModal]);

    return(
        <>
            <Modal
                isOpen={isModal}
                setIsOpen={setIsModal}
                isStaticBackdrop={true}
                isCentered={true}
                secondModal={true}
            >
                <ModalHeader setIsOpen={setIsModal}>
                    <div className="d-flex flex-column">
                        <ModalTitle>{t('합류코드를 통한 회사 참여')}</ModalTitle>

                        <div className="mt-2 fs-6 text-muted">
                            <Trans i18nKey="직장합류코드입력모달">
                                공유받은 <strong className="fw-semibold text-dark">직장 합류 코드</strong>를 입력바랍니다.
                            </Trans>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div className='py-3'>
                        <FormGroup label={t('합류코드')}>
                            <Input
                                type='text'
                                placeholder={t('6자 입력')}
                                value={code}
                                onChange={(e) => {
                                    setCode(e.target.value);
                                }}
                            />
                        </FormGroup>
                    </div>
                    <Alert isLight color="danger">
                        <div className="d-flex align-items-center gap-2">
                            <InfoOutline style={{ fontSize: '1.8em', marginTop: 1 }} />
                            <span>
                                {t('합류코드는 관리자에게서 받은 초대 이메일에서 확인 가능합니다.')}
                                <br />
                                {t('코드를 받지 못했다면 관리자에게 문의 바랍니다.')}
                            </span>
                        </div>
                    </Alert>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup>
                        <Button
                            color='danger'
                            onClick={() => {
                                setIsModal(false);
                            }}>
                            {t('취소')}
                        </Button>
                        <Button
                            isDisable={code.length >= 6 ? false : true}
                            color={code.length >= 6 ? 'success' : 'light'}
                            className={'px-5'}
                            onClick={async () => {
                                await AuthService.joinCodeCompany(code).then((res) => {
                                    showNotification(
                                        t('회사 참여'),
                                        res.data.message,
                                        res.data.result ? 'success' : 'danger',
                                    );
                                    if (res.data.result) {
                                        Promise.all([
                                            onCreated(),
                                            setCode(''),
                                            setIsModal(false),
                                        ]);
                                    }
                                });
                            }}>
                            {t('합류')}
                        </Button>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        </>
    )
};

export default JoinCompanyModal;